import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { IResponse } from '@shared/models/base/http-response.model';
import { UmCountries } from '@shared/models/umCountries.model';
import { noWhiteSpaces } from '@shared/validators/no-white-spaces.validator';
import { specialCharactersValidator } from '@shared/validators/special-characters.validator';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class CountryService {
  http = inject(HttpClient);

  public isAddressRequired = false;

  updateAddressRequiredFields(form: FormGroup): void {
    const countryControl = form.get('countryCode') || form.get('country');
    const stateControl = form.get('state') || form.get('region');
    const postalCodeControl = form.get('postalCode');
    const address1Control = form.get('address1');
    const cityControl = form.get('city');

    if (countryControl) {
      countryControl?.setValidators([Validators.required]);
      address1Control?.setValidators([Validators.required, noWhiteSpaces, specialCharactersValidator]);
      cityControl?.setValidators([Validators.required]);

      countryControl.valueChanges.subscribe((value) => {
        this.isAddressRequired = value === 'USA' || value === 'CAN';
        const isDistrictProvince = value === 'CHN' || value === 'VNM';

        form
          .get('stateLabelText')
          ?.setValue(
            this.isAddressRequired
              ? 'Generic_StateLabel'
              : isDistrictProvince
                ? 'Generic_DistrictProvince'
                : 'Generic_StateIntlLabel',
          );

        if (this.isAddressRequired) {
          const currentStateValue = stateControl?.value;
          if (currentStateValue && currentStateValue.length > 2) {
            stateControl?.setValue(currentStateValue.substring(0, 2));
          }
          stateControl?.setValidators([Validators.required]);
          postalCodeControl?.setValidators([Validators.required]);
        } else {
          this.isAddressRequired = false;
          stateControl?.setValidators([]);
          postalCodeControl?.setValidators([]);
        }

        stateControl?.updateValueAndValidity();
        postalCodeControl?.updateValueAndValidity();
        cityControl?.updateValueAndValidity();
        address1Control?.updateValueAndValidity();
      });
    }
  }

  getCountries(): Observable<IResponse<UmCountries[]>> {
    return this.http.get<IResponse<UmCountries[]>>(new URL('/Misc/GetCountries', environment.apiUrl).href);
  }
}
